/* eslint-disable @next/next/no-before-interactive-script-outside-document */
import { memo } from 'react';
import Script from 'next/script';
import { AnalyticsPixelId } from 'core/analytics/entities';
import { SnapchatScriptsService } from 'core/analytics/services';
import { CustomAppEvents } from 'core/common/entities';
import { areArraysOfPrimitivesEqual } from 'core/common/utils/areArraysOfPrimitivesEqual';
import { prepareHtml } from 'core/common/utils/prepareHtml';

type SnapchatScriptsProps = {
  ids: Array<AnalyticsPixelId>;
};

const SnapchatScripts = ({ ids }: SnapchatScriptsProps) => {
  return (
    <>
      {ids.map((id: string) => {
        return (
          <Script
            id={`snapchat-pixel-${id}`}
            key={`snapchat-pixel-${id}`}
            strategy="beforeInteractive"
            dangerouslySetInnerHTML={prepareHtml(SnapchatScriptsService.getPixelCode())}
            onReady={() => {
              try {
                const event = new Event(CustomAppEvents.SNAPCHAT_PIXEL_LOADED);
                document.dispatchEvent(event);
              } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error dispatching Snapchat pixel loaded event', error);
              }
            }}
          />
        );
      })}
    </>
  );
};

export default memo(SnapchatScripts, (prevProps, nextProps) =>
  areArraysOfPrimitivesEqual(prevProps.ids, nextProps.ids),
);
